import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency/model'
import { CurrencyIcon } from '@root/entities/currency/ui/currency-icon/currency-icon'
import { CopyButton, Truncate } from '@root/shared/ui-kit'

import type { CurrencyRef } from '@root/entities/currency/model'

type Props = {
  currency: CurrencyModel | CurrencyRef.Ref
}

export const BlacklistCurrenciesCurrencyCell: React.FC<Props> = ({
  currency,
}) => {
  if (!(currency instanceof CurrencyModel)) {
    return (
      <AddressContainer>
        <Address>
          <Truncate start={4} end={4}>
            {currency.address}
          </Truncate>
        </Address>
        <CopyButton value={currency.address} size={14} />
      </AddressContainer>
    )
  }

  return (
    <Root>
      <CurrencyIcon
        size={24}
        currency={currency}
        withNetwork
        auxIconSize={10}
      />
      <Info>
        <Ticker>{currency.ticker}</Ticker>

        <AddressContainer>
          <Address>
            <Truncate start={4} end={4}>
              {currency.address}
            </Truncate>
          </Address>
          <CopyButton value={currency.address} size={14} />
        </AddressContainer>
      </Info>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 10px;
`

const Ticker = styled(Typography)`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Info = styled.div`
  display: grid;
`

const AddressContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
  color: var(--text-9);
`

const Address = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
